import React from 'react'

const colors = {
  0: '#e4eeff',
  1: '#B3CFFF',
  2: '#91ACE5',
  3: '#6F8ACB',
  4: '#4B6AB2',
  5: '#1F4B99',
  inbed: '#ccc',
  asleep: '#aaa',
}

const meanings = {
  asleep: 'Asleep',
  inbed: 'Lying Down',
  0: 'Not Active',
  1: 'Very Lightly Active',
  2: 'Lightly Active',
  3: 'Moderately Active',
  4: 'Vigorously Active',
}

const KeyOrder = ['asleep', 'inbed', '0', '1', '2', '3', '4']

function getCoordinatesForPercent(percent) {
  const x = Math.cos(2 * Math.PI * percent - Math.PI / 2)
  const y = Math.sin(2 * Math.PI * percent - Math.PI / 2)
  return [x, y]
}

export default class PieChart extends React.Component {
  render() {
    const { data, title, subtitle } = this.props

    const total = Object.keys(data).reduce((d, key) => d + data[key], 0)
    const percents = KeyOrder.map((key) => ({
      percent: Math.round(((data[key] || 0) * 100) / total),
      key,
    }))

    // If rounding error causes the percents to not sum to 100, remove or add the
    // error to the largest bucket.
    const sum = percents.reduce((s, p) => s + p.percent, 0)
    if (percents.length && sum !== 100) {
      ;[...percents].sort((a, b) => b.percent - a.percent)[0].percent += 100 - sum
    }

    let cumulativePercent = 0

    return (
      <div className="pie-chart">
        <div className="title">{title}</div>
        <div className="subtitle">{subtitle}</div>
        <div style={{ display: 'flex', paddingTop: 5, paddingBottom: 5 }}>
          <div className="legend" style={{ flex: 1 }}>
            {percents.map(({ key, percent }) => (
              <div key={key}>
                <div
                  style={{
                    display: 'inline-block',
                    width: 14,
                    height: 11,
                    background: colors[key],
                    marginRight: 5,
                  }}
                />
                {meanings[key]} <span className="meta">{`(${percent}%)`}</span>
              </div>
            ))}
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" width="30vw" height="30vw" viewBox="-1 -1 2 2">
            {percents.map(({ key, percent }) => {
              const [startX, startY] = getCoordinatesForPercent(cumulativePercent)
              cumulativePercent += percent / 100.0
              const [endX, endY] = getCoordinatesForPercent(cumulativePercent)
              const largeArcFlag = percent > 50 ? 1 : 0

              return (
                <path
                  key={key}
                  fill={colors[key]}
                  className={`slice`}
                  d={`M ${startX} ${startY} A 1 1 0 ${largeArcFlag} 1 ${endX} ${endY} L 0 0`}
                />
              )
            })}
          </svg>
        </div>
      </div>
    )
  }
}
